// extracted by mini-css-extract-plugin
module.exports = {"formFrame":"Frame_formFrame__3lA5M","fields":"Frame_fields__1HwIi","buttons":"Frame_buttons__1KFds"};